<template>
  <div class="flex items-center">
    <button
      @click="toggle"
      class="relative inline-flex items-center h-7 w-14 rounded-full focus:outline-none bg-blue-500"
    >
      <div 
        class="w-full"
        :class="{'text-left pl-1': isActive, 'text-right pr-1': !isActive}"
      >
        <p class="text-white text-xs">{{ isActive ? 'Buy' : 'Rent' }}</p>
      </div>
      <span
        class="absolute left-0 w-6 h-6 bg-white rounded-full shadow transform transition-transform duration-300 ease-in-out"
        :class="{'translate-x-0 left-0.5': !isActive, 'translate-x-7': isActive}"
      ></span>
    </button>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isActive: true
    }
  },
  mounted() {
    this.$emit('toggleValue', 'sale')
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
      this.$emit('toggleValue', this.isActive ? 'sale' : 'rental')
    }
  }
}
</script>
